export default __webpack_public_path__ + "static/media/2018_Ke_and_Nakazawa_2018_Oikos.b5a5a70b.pdf";